module.exports = __webpack_public_path__ + "img/110014.2cecd71b.png";